import { gql } from '@apollo/client';

export const ADMIN_GET_PROS_WITHIN_REACH_FOR_JOB_AD = gql`
  query AdminGetProsWithinReachForEmployerJobAd(
    $jobAdId: String!
    $first: Int
    $after: String
    $locations: [String!]
    $categories: [String!]
    $experienceLevels: [String!]
    $availableOnly: Boolean
  ) {
    adminGetProsWithinReachForEmployerJobAd(
      jobAdId: $jobAdId
      first: $first
      after: $after
      locations: $locations
      categories: $categories
      experienceLevels: $experienceLevels
      availableOnly: $availableOnly
    ) {
      totalCount
      edges {
        cursor
        node {
          id
          firstName
          lastName
          email
          phoneNumber
          phoneNumberVerified
          jobTitle
          yearsOfExperience
          verified
          categories {
            id
            name
          }
          tags {
            id
            name
          }
          proApplication {
            stateOfResidence
            address
          }
          createdAt
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
    }
  }
`;